<template>
  <div id="mess">
    <div @click="back" class="header">
      <i class="iconfont">&#xe604;</i>
    </div>
    <div class="content">
      <div class="confirm">
        <div class="icon">
          <i class="iconfont">&#xe646;</i>
        </div>
        <div>
          <p>订单待支付</p>
          <p class="cue">订单提交成功，请支付订单</p>
        </div>
      </div>
      <div class="hint">
        <p>您的订单已提交，请尽快支付订单，商家确认订单后请联系店家取货。</p>
      </div>
    </div>
    <div class="foot">
      <button type="submit" name="submit" @click="handlePayClick">使用账户余额支付订单</button>
      <router-link tag="button" to="/order_detail">查看订单</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayMess',
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    handlePayClick () {
      this.$router.push({
        path: '/identify_verify',
        query: {
          oid: [this.$route.query.orderids],
          id: [this.$route.query.ids]
        }
      })
    }
  }
}
</script>

<style scoped>
.header{ padding: 10px 13px;}
.header .iconfont{ font-size: 25px;}
.header a{ text-decoration: none;}
.confirm{ text-align: center; background-color: #fff; padding: 15px 0; border-bottom: 5px solid #f2f2f2;}
.confirm .iconfont{ font-size: 30px; color: #fff; line-height: 55px;}
.confirm p{font-size: 14px; color: #202020;}
.confirm .cue{ font-size: 12px; color: #bbbbbb;}
.icon{ width: 55px; height: 55px; background-color: #fe3637; border-radius: 50%; margin-right: auto; margin-left: auto; margin-bottom: 5px;}
.message p{ text-align: center; font-size: 14px; color: #a3a3a3; margin-bottom: 10px;}
.message .message-title{ display: flex; justify-content: space-between; align-items: center; font-size: 14px; margin-bottom: 0;}
.message{ background-color: #fff; padding: 10px 15px; border-bottom: 5px solid #f2f2f2; padding-bottom: 3px;}
.message .mess{ padding: 7px 0;}
.message .mess p:first-child{ padding-bottom: 3px;}
.pay{ padding: 7px 0 4px 0;}
.pay p{ line-height: 45px; color: #a3a3a3; display: flex; justify-content: space-between;}
.pay span{ color: #ff0135; font-weight: bold;}
.hint{ font-size: 12px; color: #a3a3a3; background-color: #fff; padding: 15px; border-bottom: 5px solid #f2f2f2;}
.foot{ margin: 15px 0;}
.foot button{ background-color: #fe2a29; border: 0; color: #fff; font-size: 14px; width: 90%; height: 40px; display: block; margin-left: auto; margin-right: auto; margin-bottom: 8px; border-radius: 3px; font-family: Arial,"Microsoft YaHei";}
</style>



// WEBPACK FOOTER //
// src/pages/pay/components/Mess.vue